import React from "react";
import { FumigationRecord, EMPTY_RECORD } from "contexts/applicationDataFieldTypes";
import { getCloseDateOptions, getRestoreDateOptions } from '../../../utils/fumigationDateUtils';

// Re-export for convenience
export { EMPTY_RECORD };
export type { FumigationRecord };

export const INITIAL_ROWS = 10;

// ── Dropdown option lists ─────────────────────────────────────────────────────

export const ORDER_SCHEDULE_OPTIONS = ['Sched', 'Cancel'];
export const TIME_OPTIONS = ['AM', 'PM', 'AD'];
export const RESTORE_TIME_OPTIONS = ['AD', 'AM', 'PM'];

export const ACCESS_ARRANGEMENTS_OPTIONS = [
    'None',
    'Front Door Key under Front Door Mat',
    'Back Door Key under Back Door Mat',
    'Manager',
    'Front Door Key under Flower Pot',
    'Back Door Key under Flower Pot',
    'Front Door Key inside Screen Door',
    'Back Door Key inside Screen Door',
    'Gate Unlocked',
    'Small Garage Door Unlocked',
    'Large Garage Door Unlocked',
    'Key with Neighbor Left',
    'Key with Neighbor Right',
    'Key at Sales Office',
    'Additional Access/Address Info',
];

export const CODE_TYPE_OPTIONS = ['None', 'LockBox', 'Garage', 'Gate', 'Front Door', 'Back Door'];

// ── Date option generators (using legacy C# logic) ────────────────────────────

export const CLOSE_DATE_OPTIONS = getCloseDateOptions();
export const RESTORE_DATE_OPTIONS = getRestoreDateOptions();

// ── Per-row address search state ──────────────────────────────────────────────

export interface RowAddressState {
    options: string[];
    query: string;
}

// ── Shared inline styles ──────────────────────────────────────────────────────

export const BASE_FONT: React.CSSProperties = {
    fontSize: '11px',
    fontFamily: 'Arial, Helvetica, sans-serif',
};

export const TH_STYLE: React.CSSProperties = {
    ...BASE_FONT,
    color: 'blue',
    fontWeight: 'normal',
    textAlign: 'left',
    verticalAlign: 'bottom',
    padding: '2px 4px',
};

export const TD_STYLE: React.CSSProperties = {
    ...BASE_FONT,
    padding: '2px 3px',
    verticalAlign: 'middle',
};

export const INPUT_STYLE: React.CSSProperties = {
    ...BASE_FONT,
    border: '1px solid #999',
    padding: '1px 2px',
    minWidth: '50px',
    boxSizing: 'border-box',
};

export const SELECT_STYLE: React.CSSProperties = {
    ...BASE_FONT,
    border: '1px solid #999',
    padding: '1px 1px',
    minWidth: '60px',
    boxSizing: 'border-box',
};
